<template>

  <vx-card class="grid-view-item mb-base overflow-hidden mb-5" >
    <div slot="no-body">
      <img class="responsive card-img-top cursor-pointer"
           :src="classRoomPictureCompute"
           alt="content-img">
    </div>


    <div class="flex justify-between flex-wrap center" >
      <h5 class="mb-2 hover:text-primary cursor-pointer">
        {{ item.subject.code }}
      </h5>

      <vs-chip color="danger" transparent
               v-if="isOnAir">
        {{ $t('teacher-dash-board.now-on-air') }}
      </vs-chip>

      <vs-chip color="primary" transparent>
        {{ studentRegisterQty }}/{{ studentQty }}
      </vs-chip>
    </div>

    <p class="text-grey">{{ item.subject.nameLocal }}</p>

    <div class="flex justify-between flex-wrap mt-2">
      <span class="flex items-center">
        {{ $t('student-enroll.section-no') }} {{ item.classSection.sectionNo }}
      </span>

      <span class="flex items-center mr-2">
        {{ $t('student-enroll.learn-span-no') }} {{ item.classSection.learnSpanNo }}
      </span>
    </div>

    <div class="flex justify-between flex-wrap mt-2">
      <span class="flex items-center">
        {{ onAirDate }}
      </span>

      <span class="flex items-center mr-2">
          <feather-icon class="mr-2" icon="ClockIcon" svgClasses="text-dark stroke-current h-6 w-6"/>
          {{ onAirTime }}
      </span>
    </div>

    <vs-divider/>

    <span class="text-grey">{{ $t('live-class-schedule.topic') }}: </span>
    <span class="text-secondary">{{ item.topicLocal }}</span>
    <br>
    <span class="text-grey">{{ $t('live-class-schedule.live-from') }}: </span>
    <span class="text-secondary">{{ item.liveFrom }}</span>
    <br>
    <!--    EXTERNAL LIVE-->
    <div class="flex justify-between flex-wrap center" v-if="item.externalLink && canClickLink">
      <div class="flex justify-center mt-2 mb-0">
        <vs-button color="success"
                   icon="icon-link"
                   icon-pack="feather" size="small"
                   @click="goToExternalLink(item.externalLink)">
          {{ $t('advisor-online-schedule.go-to-external-link') }}
        </vs-button>
      </div>
      <div class="flex justify-center mt-2 mb-0">
        <vs-button v-clipboard:copy="item.externalPassword"
                   v-clipboard:success="onCopy" icon="icon-copy"
                   icon-pack="feather"
                   size="small">
          {{ $t('live-class-schedule.copy-password') }}
        </vs-button>
      </div>
    </div>

    <!--    REPORT-->
    <div class="flex justify-center flex-wrap center mt-2" v-if="item.yeaLinkImportDataQty > 0">
        <vs-button color="primary"
                   icon="icon-download"
                   icon-pack="feather"
                   @click="handlerLiveClassRecordClick(item.id)">
          {{ $t('home.live-class-record') }}
        </vs-button>
    </div>

    <!--    NORMAL LIVE-->
<!--    <div class="flex justify-center mt-2 mb-0" v-if="!item.externalPassword">
      <vs-button size="medium"
                 icon-pack="feather" icon="icon-copy"
                 v-clipboard:copy="streamKey"
                 v-clipboard:success="onCopy">
        {{ $t('teacher-dash-board.copy-stream-key') }}
      </vs-button>
    </div>-->
    <!--<div class="flex justify-center flex-wrap center mt-2 ">
      <div class="flex flex-wrap center">

        <span class="flex mr-3">
          <feather-icon icon="BookIcon" svgClasses="text-success stroke-current hover:text-primary h-6 w-6"/>
          <span class="ml-2 mt-1 hover:text-primary">{{ $t('teacher-dash-board.home-work') }}</span>
        </span>

        <span class="flex mr-3">
          <feather-icon icon="UploadIcon" svgClasses="text-warning stroke-current h-6 w-6"/>
          <span class="ml-2 mt-1 hover:text-primary">{{ $t('teacher-dash-board.submit-score') }}</span>
        </span>

        <span class="flex mr-3">
          <feather-icon icon="BarChart2Icon" svgClasses="text-danger stroke-current h-6 w-6"/>
          <span class="ml-2 mt-1 hover:text-primary">{{ $t('teacher-dash-board.student-stat') }}</span>
        </span>

      </div>
    </div>-->

    <!--SLOT: ACTION BUTTONS -->
    <slot name="action-buttons"/>

  </vx-card>

</template>

<script>
  import moment from 'moment';
  import {dateTimeFormat} from '@/utils/format';
  import {config, getClassRoomUrl} from "@/utils/upload";
  import {showLocalNotification, notificationType} from "@/utils/notification";
  import {APIServerPrisma2} from "@/constants/config";

  export default {
    props: [
      'item',
      'index',
    ],
    data(){
      return {
        classRoomPicture: this.getClassRoomPicture(this.item),
      }
    },
    computed: {
      studentRegisterQty(){
        if(this.item.classSection){
          return this.item.classSection.studentRegisterQty;
        }
        return 0
      },
      studentQty(){
        if(this.item.classSection && this.item.classSection.classRoom){
          return this.item.classSection.classRoom.capacity;
        }
        return 0
      },
      classRoomPictureCompute(){
        return this.classRoomPicture;
      },
      onAirDateStringShort(){
        if (this.item) {
          let dateFrom = this.item.dateTimeFrom;

          return moment(dateFrom).locale(this.$i18n.locale).format('ddd').toUpperCase();
        } else {
          return '-';
        }
      },
      onAirDateShort(){
        if (this.item) {
          let dateFrom = this.item.dateTimeFrom;

          return moment(dateFrom).format('DD');
        } else {
          return '-';
        }
      },
      onAirDate() {
        if (this.item) {
          let dateFrom = this.item.dateTimeFrom;

          return moment(dateFrom).format(dateTimeFormat.momentYYYYMMDD);
          // return moment(dateFrom).locale(this.$i18n.locale).format('ddd, MMM DD, YYYY');
        } else {
          return '-';
        }
      },
      onAirTime(){
        if (this.item) {
          let dateFrom = this.item.dateTimeFrom;
          let dateTo = this.item.dateTimeTo;

          return moment(dateFrom).format(dateTimeFormat.momenthhmm)
            + ' - ' + moment(dateTo).format(dateTimeFormat.momenthhmm);
          // return moment(dateFrom).format(dateTimeFormat.momenthhmm + ' A')
          //   + ' - ' + moment(dateTo).format(dateTimeFormat.momenthhmm + ' A');
        } else {
          return '-';
        }
      },
      isOnAir(){
        let dateFrom = moment(this.item.dateTimeFrom);
        let dateTo = moment(this.item.dateTimeTo);

        return moment(new Date()).isBetween(dateFrom, dateTo);
      },
      streamKey(){
        return this.item.rtmpServer + this.item.rtmpStream;
      },
      canClickLink(){
        let dateTimeTo = moment(this.item.dateTimeTo);

        return moment(new Date()).isSameOrBefore(dateTimeTo);
      },
    },
    methods: {
      //---------------------------------------- Event Function ------------------------------------------------------//
      onCopy(){
        showLocalNotification(this.$vs
          , this.$t('general.success'),
          this.$t('teacher-dash-board.copy-success')
          , notificationType.SUCCESS);

      },
      navigateToEditLiveClass() {
        /*this.$router.push({
          name: 'class-room-overview',
          params: {
            courseOutlineRegistrationId: this.item.courseOutlineRegistration.id
          }
        })
        .catch(() => {
        })*/
      },
      goToExternalLink(link){
        window.open(link, '_blank');
      },
      handlerLiveClassRecordClick(liveClassScheduleId){
        const rsc = JSON.parse(localStorage.getItem("rsc"));
        let entity, stage
        if (rsc) {
          entity = rsc.e_code;
          stage = rsc.r_stage;
        }
        let url = APIServerPrisma2
          + '/api/export_excel_live_class_record'
          + '/' + liveClassScheduleId
          + '/' + entity
          + '/' + stage;
        window.open(url, '_self');
      },
      //---------------------------------------- Local Function ------------------------------------------------------//
      getClassRoomPicture(item){
        if(item.courseOutlineRegistration.courseOutline.picturePath){
          return getClassRoomUrl(item.courseOutlineRegistration.courseOutline.picturePath);
        }else{
          let indexStr = String(this.index);
          let classRoomPlaceholderIndex = String(indexStr).substr(indexStr.length - 1, indexStr.length) ;
          return config.baseUrl + 'static/images/classroom-placeholder-' + classRoomPlaceholderIndex + '.jpeg';
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .grid-view-item {
    .grid-view-img {
      max-width: 100%;
      max-height: 100%;
      width: auto;
      transition: .35s;
    }

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0px 4px 25px 0px rgba(0,0,0,.25);

      .grid-view-img{
        opacity: 0.9;
      }
    }
  }
</style>
